export interface PopupState {
  open: boolean;
  position?: PopupPosition;
}

export enum PopupPosition {
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}
